import RailsNestedForm from '@stimulus-components/rails-nested-form';

export default class extends RailsNestedForm {
  add(e) {
    e.preventDefault();

    const content = this.templateTarget.innerHTML
      .replace(/NEW_RECORD/g, new Date().getTime().toString())
      .replace(/NEW_UUID/g, crypto.randomUUID());
    this.targetTarget.insertAdjacentHTML('beforebegin', content);

    const event = new CustomEvent('rails-nested-form:add', { bubbles: true });
    this.element.dispatchEvent(event);
  }
}
